import React, {ChangeEvent} from 'react';
import ReadOnly from '../../../../shared/components/dataEntry/ReadOnly';

interface CustomInputProps{
  className?: string,
  title: string,
  placeholder: string,
  onChange: any,
  value: any,
  error: any,
  watch: boolean,
}

export default function CustomInput({
  className, title, placeholder, onChange, error, value,watch
}: CustomInputProps) {
  return (
    <div className={`${className || ''} flexCol`}>
      <p>{title}</p>
      <div className="inputMarginTop">
        <ReadOnly condition={watch}>
          <input
            className="roundedBord ant-input"
            name="customInput"
            placeholder={placeholder}
            onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
            style={{ width: '100%' }}
            defaultValue={value}
            disabled={watch}
          />
        </ReadOnly>
      </div>
      <div>
        {(error && (
          <p className="errors">{error.message}</p>
        ))
        }
      </div>
    </div>
  );
}
